export function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== "object") return false;
  const proto = Object.getPrototypeOf(value);

  return proto === Object.prototype || proto === null;
}

export function normalizeEmptyString<T>(value: T): T {
  if (value === "") return null as T;

  if (Array.isArray(value)) {
    return value.map(normalizeEmptyString) as T;
  }

  //Reason: If you don't check for plain objects, this will break especially DayJs
  //Potentially creates unserializable objects for the api to consume
  if (value && isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, normalizeEmptyString(v)])
    ) as T;
  }

  return value;
}
